<template>
  <div>
    <div class="header">
      <b-col cols="6">
        <p class="text-header">{{ id > 0 ? "update" : "create" }} branch</p>
      </b-col>
      <b-col cols="6" class="text-right">
        <div v-if="$isEventGroup">
          <b-dropdown
            v-if="language"
            :text="language.name"
            class="m-md-2"
            right
          >
            <b-dropdown-item
              v-for="(item, index) in listLang"
              :key="index"
              @click="changeLanguage(item, index)"
            >
              <div :class="language.languageId === item.languageId && `item`">
                {{ item.name }}
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </b-col>
    </div>
    <b-container class="bv-example-row bv-example-row-flex-cols">
      <div class="my-3">
        <b-row>
          <b-col sm="12" :md="branchCodeFlag ? '6' : '12'"
            ><InputText
              v-model="form.translationList[indexLanguage].name"
              class="input"
              :textFloat="`BranchName`"
              placeholder="BranchName"
              type="text"
              name="name"
              isRequired
              :v="$v.form.translationList.$each[indexLanguage].name"
              :isValidate="
                $v.form.translationList.$each[indexLanguage].name.$error
              "
              :selectLang="$isEventGroup ? language : undefined"
          /></b-col>
          <b-col sm="12" md="6" v-if="branchCodeFlag">
            <InputText
              v-model="form.branchCode"
              class="input"
              :textFloat="`BranchCode`"
              placeholder="BranchCode`"
              type="text"
              name="name"
              isRequired
              :v="$v.form.branchCode"
              :isValidate="$v.form.branchCode.$error"
              :selectLang="$isEventGroup ? language : undefined"
          /></b-col>
        </b-row>
      </div>

      <div>
        <TextEditorsTiny
          :value="form.translationList[indexLanguage].description"
          textFloat="Description"
          :rows="4"
          :name="'description_' + 1"
          placeholder="Type something..."
          @onDataChange="
            (val) => (form.translationList[indexLanguage].description = val)
          "
          :v="$v.form.translationList.$each[indexLanguage].description"
          :isValidate="
            $v.form.translationList.$each[indexLanguage].description.$error
          "
          isRequired
          :selectLang="$isEventGroup ? language : undefined"
        />
      </div>

      <div class="my-3">
        <InputTextArea
          v-model="form.translationList[indexLanguage].businessTime"
          class="input"
          :textFloat="`Business Time`"
          placeholder="Business Time"
          type="text"
          rows="4"
          name="businessTime"
          isRequired
          :v="$v.form.translationList.$each[indexLanguage].businessTime"
          :isValidate="
            $v.form.translationList.$each[indexLanguage].businessTime.$error
          "
          :selectLang="$isEventGroup ? language : undefined"
        />
      </div>

      <div class="my-3">
        <InputTextArea
          v-model="form.translationList[indexLanguage].venueAddress"
          class="input"
          :textFloat="`Address`"
          placeholder="Address"
          type="text"
          rows="8"
          name="name"
          isRequired
          :v="$v.form.translationList.$each[indexLanguage].venueAddress"
          :isValidate="
            $v.form.translationList.$each[indexLanguage].venueAddress.$error
          "
          :selectLang="$isEventGroup ? language : undefined"
        />
      </div>
      <b-row>
        <b-col>
          <div class="my-3">
            <InputSelect
              v-model="form.locationId"
              :options="listProvince"
              title="Province"
              class="mt-2"
              valueField="id"
              textField="name"
              isRequired
              :v="$v.form.locationId"
              :isValidate="$v.form.locationId.$error"
            >
              <template v-slot:option-first>
                <b-form-select-option :value="null" disabled
                  >-- Select Province --</b-form-select-option
                >
              </template>
            </InputSelect>
          </div>
        </b-col>
        <b-col>
          <div class="my-3">
            <InputText
              v-model="form.locationUrl"
              class="input"
              :textFloat="`Google map url`"
              placeholder="Google map url"
              type="text"
              name="name"
              @onDataChange="onChangeLocationUrl"
              isRequired
              :v="$v.form.locationUrl"
              :isValidate="$v.form.locationUrl.$error"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="my-3">
            <InputText
              v-model="form.latitude"
              class="input"
              :textFloat="`latitude`"
              placeholder="latitude"
              type="number"
              name="name"
              isRequired
              :v="$v.form.latitude"
              :isValidate="$v.form.latitude.$error"
            />
          </div>
        </b-col>
        <b-col>
          <div class="my-3">
            <InputText
              v-model="form.longitude"
              class="input"
              :textFloat="`longitude`"
              placeholder="longitude"
              type="number"
              name="name"
              isRequired
              :v="$v.form.longitude"
              :isValidate="$v.form.longitude.$error"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="my-3">
            <InputText
              v-model="form.telephone"
              class="input"
              :textFloat="`Telephone`"
              placeholder="Telephone"
              type="text"
              name="name"
              isRequired
              :v="$v.form.telephone"
              :isValidate="$v.form.telephone.$error"
            />
          </div>
        </b-col>
      </b-row>
      <b-row v-if="dutationFlag === true"
        ><b-col sm="12" md="6">
          <InputText
            textFloat="Duration (Minute)"
            placeholder="0"
            type="number"
            name="number"
            v-model="form.dutation"
            :v="$v.form.dutation"
            isRequired
            :isValidate="$v.form.dutation.$error"
        /></b-col>

        <b-col sm="12" md="6">
          <InputText
            textFloat="Buffer time after (Minute)"
            placeholder="0"
            type="number"
            name="number"
            v-model="form.bufferTimeAfter" /></b-col
      ></b-row>
    </b-container>

    <div v-if="!form.isLockRoom">
      <RoomForm
        :id="+$route.params.id || 0"
        :selected-lang="selectedLang"
        :index-language="indexLanguage"
      />
    </div>
    <div class="container-right mt-4">
      <b-button @click="handleSaveBranch" class="w-200 btn">{{
        this.formStep ? "Next" : this.id > 0 ? "Update" : "Create"
      }}</b-button>
    </div>
    <ModalAlertText
      :textModal="textModal"
      :arrModal="arrStatus"
      @clearArrModal="closeModal"
    />
  </div>
</template>

<script>
import AutocompleteCustom from "@/components/inputs/AutocompleteCustom";
import RoomForm from "./roomForm.vue";
import ModalAlertText from "@/components/modal/ModalAlertText.vue";
import {
  required,
  requiredIf,
  minValue,
  url,
  minLength,
  maxLength,
  numeric,
  decimal,
} from "vuelidate/lib/validators";
export default {
  name: "BranchForm",
  components: { AutocompleteCustom, RoomForm, ModalAlertText },
  data() {
    return {
      form: {
        locationId: null,

        translationList: [
          {
            id: 0,
            name: "",
            languageId: 2,
            venueAddress: "",
            description: "",
            businessTime: "",
          },
          {
            id: 0,
            name: "",
            languageId: 1,
            venueAddress: "",
            description: "",
            businessTime: "",
          },
        ],
      },

      selectedLang: 2,
      isLoading: false,
      listLang: [],
      listProvince: [],

      // state modal
      textModal: "",
      arrStatus: [],
    };
  },
  validations() {
    return {
      form: {
        branchCode: {
          required: requiredIf(() => this.branchCodeFlag === true),
        },
        dutation: {
          required: requiredIf(() => this.dutationFlag === true),
          minValue: minValue(1),
        },
        latitude: {
          required,
          decimal,
        },
        longitude: {
          required,
          decimal,
        },
        locationUrl: {
          required,
          url,
        },
        locationId: { required },
        telephone: {
          required,
          minLength: minLength(9),
          maxLength: maxLength(10),
          numeric,
        },
        translationList: {
          $each: {
            name: {
              required,
            },
            venueAddress: {
              required,
            },
            description: {
              required,
            },
            businessTime: {
              required,
            },
          },
        },
      },
    };
  },
  props: {
    visible: {
      required: true,
      type: Boolean,
    },
    id: {
      required: true,
      type: Number,
    },
    formStep: {
      type: Boolean,
      default: false,
    },
    dutationFlag: {
      type: Boolean,
      default: false,
    },
    branchCodeFlag: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  watch: {
    visible(val) {
      this.$v.$reset();
      this.isLoading = true;
      if (val === true) {
        this.getLanguageOption();
        this.getProvinceOption();

        this.getDefaultForm(this.id);
      }
      this.isLoading = false;
    },
  },
  computed: {
    language() {
      return this.listLang.find((x) => x.languageId === this.selectedLang);
    },
    indexLanguage() {
      return this.form.translationList.findIndex(
        (x) => x.languageId === this.selectedLang
      );
    },
  },
  methods: {
    async getDefaultForm(id) {
      const respone = await this.$services.venue.getVenueById(id);

      this.form = respone.detail;
      if (this.form.locationId === 0) this.form.locationId = null;
    },
    async getLanguageOption() {
      const getData = await this.$services.master.getLanguageOption();

      if (getData.result == 1) {
        this.listLang = getData.detail;
        this.selectedLang = this.listLang[0].languageId;
      }
    },
    async getProvinceOption() {
      const respone = await this.$services.master.getOptionProvince();
      this.listProvince = respone.detail.map((o) => {
        return { id: o.locationId, name: o.name };
      });
    },

    async handleSaveBranch() {
      this.form.translationList = this.setDataLanguage(
        this.form.translationList[this.indexLanguage]
      );

      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }
      if (this.formStep) {
        this.$emit("onClickNext", this.form);
      } else {
        this.isLoading = true;
        if (this.form.locationId === 0) this.form.locationId = null;

        this.$services.venue.saveVenue(this.form).then(async (res) => {
          const respone = await res;
          this.openModalAlertText(respone.message);
        });
        this.isLoading = false;
      }
    },
    clearForm() {
      this.$emit("clearForm");
      this.isLoading = false;
    },

    onChangeLocationUrl() {},

    openModalAlertText(text) {
      this.textModal = text;
      this.$bvModal.show("modal-alert-text");
    },
    closeModal() {
      this.$router.push(`/branch`);
    },
    changeLanguage(v) {
      this.selectedLang = v.languageId;
    },
    setDataLanguage(data) {
      return this.form.translationList.map((item) => {
        return { ...data, id: item.id, languageId: item.languageId };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  .item {
    color: var(--secondary-color);
  }
}
.btn {
  background-color: var(--secondary-color);
  color: white;
}

.container-right {
  display: flex;
  justify-content: right;

  align-items: center;

  .box-lang {
    padding: 5px 10px;
    margin-right: 5px;
    border: 1px solid black;
    cursor: pointer;

    &.active {
      background: var(--secondary-color);
      color: white;
    }
  }
}
.text-header {
  color: #092d53;
  font-weight: 600;
  font-size: 20px;
  text-transform: uppercase;
}
</style>
